import CoinAmount from "./CoinAmount.jsx";

export default function WinnersTable({
  className,
  visibleRows,
  onSort,
  renderSortLabel,
  onSelectParticipant,
  formatPercent,
  selectable = false,
  selectedParticipantKeys = new Set(),
  onToggleParticipant,
}) {
  const formatLuckScore = (value) => `${value >= 0 ? "+" : ""}${value.toFixed(2)}`;

  return (
    <div
      className={className}
      style={{
        borderRadius: 14,
        border: "1px solid rgba(144,224,239,0.24)",
        overflowX: "auto",
        background: "rgba(6, 18, 38, 0.75)",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 860 }}>
        <thead>
          <tr style={{ background: "rgba(14, 44, 78, 0.75)" }}>
            {selectable ? <th style={{ padding: 10, textAlign: "left" }}>Select</th> : null}
            <th style={{ padding: 10, textAlign: "left" }}>
              <button className="names-btn secondary" onClick={() => onSort("rank")}>
                {renderSortLabel("Ranking", "rank")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "left" }}>
              <button className="names-btn secondary" onClick={() => onSort("name")}>
                {renderSortLabel("Name", "name")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "right" }}>
              <button className="names-btn secondary" onClick={() => onSort("gamesParticipated")}>
                {renderSortLabel("Games", "gamesParticipated")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "right" }}>
              <button className="names-btn secondary" onClick={() => onSort("attendance")}>
                {renderSortLabel("Attendance", "attendance")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "right" }}>
              <button className="names-btn secondary" onClick={() => onSort("winRate")}>
                {renderSortLabel("Win Rate", "winRate")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "right" }}>
              <button className="names-btn secondary" onClick={() => onSort("luckScore")}>
                {renderSortLabel("Luck Score", "luckScore")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "right" }}>
              <button className="names-btn secondary" onClick={() => onSort("wins")}>
                {renderSortLabel("Total Wins", "wins")}
              </button>
            </th>
            <th style={{ padding: 10, textAlign: "right" }}>
              <button className="names-btn secondary" onClick={() => onSort("totalValue")}>
                {renderSortLabel("Total value", "totalValue")}
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((row) => (
            <tr
              key={row.key}
              onClick={() => onSelectParticipant(row.key)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onSelectParticipant(row.key);
                }
              }}
              role="button"
              tabIndex={0}
              title="Open participant details"
              style={{
                borderTop: "1px solid rgba(144,224,239,0.12)",
                cursor: "pointer",
              }}
            >
              {selectable ? (
                <td style={{ padding: 10 }} onClick={(event) => event.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedParticipantKeys.has(row.key)}
                    onChange={() => onToggleParticipant(row.key)}
                    aria-label={`Select ${row.name}`}
                  />
                </td>
              ) : null}
              <td style={{ padding: 10, color: "#dff8ff", fontWeight: 700 }}>#{row.rank}</td>
              <td style={{ padding: 10, color: "#eefbff", fontWeight: 700 }}>{row.name}</td>
              <td style={{ padding: 10, textAlign: "right", color: "#eefbff" }}>{row.gamesParticipated}</td>
              <td style={{ padding: 10, textAlign: "right", color: "#eefbff" }}>{formatPercent(row.attendance)}</td>
              <td style={{ padding: 10, textAlign: "right", color: "#eefbff" }}>{formatPercent(row.winRate)}</td>
              <td
                style={{
                  padding: 10,
                  textAlign: "right",
                  color: row.luckScore >= 0 ? "#9ef0b0" : "#ff9d9d",
                  fontWeight: 700,
                }}
              >
                {formatLuckScore(row.luckScore)}
              </td>
              <td style={{ padding: 10, textAlign: "right", color: "#ffea9a", fontWeight: 700 }}>{row.wins}</td>
              <td style={{ padding: 10, textAlign: "right", color: "#d8f5ff" }}>
                <CoinAmount value={row.totalValue} compact />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
